import React from "react";
import { useTranslation } from "react-i18next";

import { I18N_NAMESPACES, RECIPE_TYPES } from "../../../helpers/constants";
import { generateImageUrl } from "../../../helpers/ghost";
import defaultCardPhoto from "../../../assets/images/guides/default-image.jpg";
import { GhostPostType } from "../../../types/ghost";
import {
  CardWrapperLink,
  CardImage,
  CardBottomPanel,
  CardHeaderWrapper,
  PostTitle,
  RecipeTitle,
  RecipeTypeAndReadingTime,
} from "./style";

interface Props {
  blogPost: GhostPostType;
  isLastBlogPost: boolean;
}

const WineDetailsRecipeCard = ({ blogPost, isLastBlogPost }: Props) => {
  const { t } = useTranslation([I18N_NAMESPACES.MY_DASHBOARD, I18N_NAMESPACES.WINE_PAGES]);

  const cardImage = blogPost?.feature_image ? generateImageUrl(blogPost?.feature_image) : defaultCardPhoto;

  const recipeTag = blogPost?.tags?.filter((tag) => RECIPE_TYPES.includes(tag?.name))?.[0]?.name;

  return (
    // TODO: Open blog post within the app
    // https://linear.app/goodpairdays/issue/PRO-293
    <CardWrapperLink to={{ pathname: blogPost?.url }} target="_blank" isLastBlogPost={isLastBlogPost}>
      <CardHeaderWrapper>
        <CardImage src={cardImage} />
      </CardHeaderWrapper>
      <CardBottomPanel>
        <PostTitle>{t("winePages:recipesAndPairings")}</PostTitle>
        <RecipeTitle>{blogPost?.title || ""}</RecipeTitle>
        <RecipeTypeAndReadingTime>
          {t("winePages:recipeTypeAndReadingTime", {
            minutes: blogPost?.reading_time || 1,
            type: recipeTag ?? blogPost?.tags?.[2]?.name,
          })}
        </RecipeTypeAndReadingTime>
      </CardBottomPanel>
    </CardWrapperLink>
  );
};

export default WineDetailsRecipeCard;
